import { render, staticRenderFns } from "./visualizar_FormatoConvenio.vue?vue&type=template&id=50927b22&scoped=true"
import script from "./visualizar_FormatoConvenio.vue?vue&type=script&lang=js"
export * from "./visualizar_FormatoConvenio.vue?vue&type=script&lang=js"
import style0 from "./visualizar_FormatoConvenio.vue?vue&type=style&index=0&id=50927b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50927b22",
  null
  
)

export default component.exports